import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0da530e2&scoped=true"
import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=0da530e2&prod&scoped=true&lang=less"
import style1 from "./index.vue?vue&type=style&index=1&id=0da530e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da530e2",
  null
  
)

export default component.exports